import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import dompurify from "isomorphic-dompurify";
import { ResponsiveContainer } from "../../responsive-container/ResponsiveContainer";
import { RestrictionMessage } from "./RestrictionMessage/RestrictionMessage";
import styles from "./PreviewContent.module.scss";
const { sanitize } = dompurify;
export const PreviewContent = ({ primaryBtnUrl, secondaryBtnUrl, isLogged, isAvailable, previewContent, primaryBtnUrlRestricted, isInEditor, disableTiers, richTextComponent, }) => {
    if (isAvailable && isLogged && !isInEditor)
        return null;
    const isEditorView = isInEditor ? false : isLogged;
    const restrictedMessageProps = {
        primaryBtnUrl,
        secondaryBtnUrl,
        isLogged: isEditorView,
        primaryBtnUrlRestricted,
        isInEditor,
        richTextComponent,
    };
    const showAuthoringPreviewTierRestrictionContent = isInEditor && !disableTiers;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.previewContent, "data-testid": "previewContent", children: _jsx(ResponsiveContainer, { size: "medium", children: _jsx("p", { dangerouslySetInnerHTML: { __html: sanitize(previewContent) } }) }) }), _jsx(RestrictionMessage, { ...restrictedMessageProps, dataTestId: "restrictionMessage" }), showAuthoringPreviewTierRestrictionContent && (_jsx(RestrictionMessage, { ...restrictedMessageProps, isLogged: true, dataTestId: "restrictionMessageEditorPreview" }))] }));
};
//# sourceMappingURL=PreviewContent.js.map